export { default as DocumentTypeSelection } from './DocumentTypeSelection';
